(function ($) {
  'use strict';

  Drupal.behaviors.thinkgp_new = {
    attach: function(context, settings) {
      //Change User block route name for thinkgp_myactivities.myactivities
      let menuTitle = $(context).find('#block-user .menu-container ul li:first a');
      menuTitle.text(menuTitle.text() === 'My Dashboard' ? 'Incomplete activities' : menuTitle.text());

      let loginTabElement = $(context).find('.local-task-wrapper .tabs li a[href="/user/login"');
      if (loginTabElement) {
        loginTabElement.text('Sign in')
      }

      if (window.location.hash) {
        var hash = window.location.hash;

        if (hash == "#incomplete-courses") {
          $('html, body').animate({ scrollTop: $("#block-user").offset().top - 150 }, 250, 'linear');
        }
      }

      const footerCookieSettingsLink = document.querySelector('.ot-sdk-show-settings');

      if (footerCookieSettingsLink) {
        footerCookieSettingsLink.addEventListener('click', (e) => e.preventDefault())
      }

    }

  };

  Drupal.behaviors.select2 = {

    //$('.form-select').select2();
    attach: function(context, settings) {
      if ($('.form-select').length > 0) {
        setTimeout(function () {
          $('.form-select').select2();
        }, 50);
      }
    }
  };

  const requiredFields = document.querySelectorAll('.js-form-type-checkbox label.js-form-required') 
  if (requiredFields.length > 0 ) {
    requiredFields.forEach(label => {
      const asterisk = document.createElement('span');
      asterisk.classList.add('asterisk');
      asterisk.innerText = "*";
      label.appendChild(asterisk);
    })
  }


}(jQuery));
